import { useDispatch } from "react-redux";

import { useChartsContext } from "contexts/ChartContext";
import { updateChartByPath } from "store/features";
import { EvaChartFeatures } from "types";

/**
 * Custom hook for handling chart feature numeric value changes
 * @returns Object containing handlers for numeric changes and toggles
 */
export function useChartFeatureHandlers() {
  const dispatch = useDispatch();
  const { id } = useChartsContext();

  const handleNumericChange =
    (key: keyof EvaChartFeatures) => (v: number | string | null) => {
      dispatch(
        updateChartByPath({
          id,
          path: `features.${key}.properties.value`,
          value: v
        })
      );
    };

  const handleToggle = (key: keyof EvaChartFeatures) => (active: boolean) => {
    dispatch(
      updateChartByPath({
        id,
        path: `features.${key}.active`,
        value: active
      })
    );
    if (key === "useLineOfBestFit" && !active) {
      dispatch(
        updateChartByPath({
          id,
          path: `features.useProbitLineOfBestFitData.active`,
          value: false
        })
      );
    }
  };

  const updateChartPath = (path: string, value: Primitive) => {
    dispatch(
      updateChartByPath({
        id,
        path,
        value
      })
    );
  };

  return {
    handleNumericChange,
    handleToggle,
    updateChartPath
  };
}
